export var pickAxisId = (_state, _axisType, axisId) => axisId;